/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Title_RecipesInputs */

const en_title_recipes = /** @type {(inputs: Title_RecipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipes`)
};

const de_title_recipes = /** @type {(inputs: Title_RecipesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezepte`)
};

/**
* | output |
* | --- |
* | "Recipes" |
*
* @param {Title_RecipesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const title_recipes = /** @type {((inputs?: Title_RecipesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Title_RecipesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_title_recipes(inputs)
	return en_title_recipes(inputs)
});